let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eXqXX")).then(() => parcelRequire('bJLF2'));